/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Unser Team arbeitet an der Lösung des Problems. Sie können es später noch einmal versuchen oder`
};

const en_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Our team is currently working to solve the problem. You can try again later or`
};

const es_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Nuestro equipo está trabajando para resolver el problema. Puedes volver a intentarlo más tarde o`
};

const fr_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Notre équipe s’active pour résoudre le problème. Vous pouvez réessayer plus tard ou`
};

const it_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Il nostro team sta lavorando per risolvere il problema. Puoi riprovare più tardi oppure`
};

const nl_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Ons team werkt aan een oplossing voor het probleem. U kunt het later opnieuw proberen of`
};

const pt_error__500__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `A nossa equipa está a trabalhar para resolver o problema. Podes tentar novamente mais tarde ou`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_start = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__500__text_start(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__500__text_start", locale)
	if (locale === "de") return de_error__500__text_start(inputs)
	if (locale === "en") return en_error__500__text_start(inputs)
	if (locale === "es") return es_error__500__text_start(inputs)
	if (locale === "fr") return fr_error__500__text_start(inputs)
	if (locale === "it") return it_error__500__text_start(inputs)
	if (locale === "nl") return nl_error__500__text_start(inputs)
	return pt_error__500__text_start(inputs)
};